import { render, staticRenderFns } from "./Caldera.vue?vue&type=template&id=0ff27ce6&"
import script from "./Caldera.vue?vue&type=script&lang=js&"
export * from "./Caldera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports